var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1233_16256",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1233_16256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1181 0H-4.11719V20H24.1181V0Z",
    fill: "#024DA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9953 2.39255L9.76694 3.14946L9.02148 3.14855L9.62621 3.61055L9.39948 4.35764L9.9953 3.89564L10.5911 4.35764L10.3651 3.61091L10.9695 3.14855H10.2237L9.9953 2.39255Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4874 5.23855L13.0839 4.77583L13.679 5.23855L13.4526 4.49164L14.0577 4.02873H13.311L13.0832 3.27255L12.8552 4.03037L12.1094 4.02873L12.7137 4.49164L12.4874 5.23855Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3351 7.16837L15.931 7.63019L15.7039 6.88328L16.309 6.42201H15.5639L15.3351 5.6651L15.1066 6.42292L14.3613 6.42201L14.9666 6.88328L14.7393 7.63019L15.3351 7.16837Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1535 10.44L16.7493 10.9029L16.523 10.1558L17.1281 9.69381H16.3822L16.1535 8.9369L15.9255 9.69472L15.1797 9.69381L15.7848 10.1558L15.5584 10.9029L16.1535 10.44Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3351 12.2276L15.5639 12.9845H16.309L15.7039 13.4465L15.931 14.1936L15.3351 13.7309L14.7393 14.1936L14.9666 13.4465L14.3613 12.9845L15.1066 12.9854L15.3351 12.2276Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0754 14.63L13.3032 15.3862H14.0492L13.4439 15.8482L13.6712 16.5951L13.0754 16.1333L12.4796 16.5951L12.7059 15.8482L12.1016 15.3862L12.8467 15.3869L13.0754 14.63Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 15.4998L10.229 16.256H10.975L10.3699 16.7178L10.597 17.4649L10.0012 17.0031L9.40534 17.4649L9.63171 16.7178L9.02734 16.256L9.77244 16.2567L10.0012 15.4998Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91522 14.63L7.14304 15.3862H7.88904L7.28377 15.8482L7.51104 16.5951L6.91522 16.1333L6.31941 16.5951L6.54577 15.8482L5.94141 15.3862L6.6865 15.3869L6.91522 14.63Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65546 12.228L4.88328 12.9842H5.62928L5.02419 13.4462L5.25128 14.1933L4.65546 13.7313L4.05964 14.1933L4.286 13.4462L3.68164 12.9842L4.42673 12.9849L4.65546 12.228Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82733 8.94637L4.05533 9.70255H4.80115L4.19606 10.1644L4.42315 10.9115L3.82733 10.4496L3.23152 10.9115L3.45788 10.1644L2.85352 9.70255L3.59861 9.70327L3.82733 8.94637Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65546 5.67455L4.88328 6.43073H5.62928L5.02419 6.89273L5.25128 7.63982L4.65546 7.17782L4.05964 7.63982L4.286 6.89273L3.68164 6.43073L4.42673 6.43164L4.65546 5.67455Z",
    fill: "#FFF100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91132 3.27219L7.13914 4.02837H7.88514L7.28005 4.49037L7.50714 5.23746L6.91132 4.77546L6.3155 5.23746L6.54186 4.49037L5.9375 4.02837L6.68259 4.0291L6.91132 3.27219Z",
    fill: "#FFF100"
  }))));
}

export default __webpack_public_path__ + "media/d11fbed7.svg";
export { SvgEuro as ReactComponent };